import { render, staticRenderFns } from "./PrevButton.vue?vue&type=template&id=b79a3190&"
import script from "./PrevButton.vue?vue&type=script&lang=js&"
export * from "./PrevButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports